<template>
    <div class="global-search-container">
        <div class="global-search-container--header">
            <slot name="header">
                <h1>Header</h1>
                <p>Header content goes here</p>
            </slot>
        </div>
        <div class="global-search-container--body">
            <div class="global-search-container--left-section">
                <slot name="left">
                    <h2>Left Section</h2>
                    <p>Left section content goes here</p>
                </slot>
                <div class="global-search-container--footer">
                    <span>
                        Hold
                        <span v-if="isMacOs">
                            <KeyboardIcon icon="⌘ Command"></KeyboardIcon>
                        </span>
                        <span v-else-if="isWindows">
                            <KeyboardIcon icon="Ctrl"></KeyboardIcon>
                        </span>
                        and click to open in a new tab.
                    </span>
                </div>
            </div>
            <div class="global-search-container--right-section">
                <slot name="right">
                    <h2>Right Section</h2>
                    <p>Right section content goes here</p>
                </slot>
            </div>
        </div>
        <slot name="notification"></slot>
    </div>
</template>

<script setup lang="ts">
import KeyboardIcon from 'src/components/elements/KeyboardIcon.vue';
const isMacOs = /macintosh|mac os x/i.test(window.navigator.userAgent);
const isWindows = /windows|win32/i.test(window.navigator.userAgent);
</script>
